module.exports = __webpack_public_path__ + "static/img/アセット 17@2x.b59ceee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_history/アセット 17@2x.png
// module id = r0FH
// module chunks = 1